// extracted by mini-css-extract-plugin
export default {"table":"sB7qH1uaVn1iaoBuCD8H"};